import { Component, OnInit } from '@angular/core';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { PermitLinked } from 'app/interfaces/PermitLinked';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { PermitTypeDocumentService } from 'app/services/permit-type-document.service';
import { Router } from '@angular/router';
import { DOCUMENT_LINK_DELINK_ACTION, LINK_PERMITS_DOCUMENT_ACTIONS } from 'app/shared/actions/actions.constants';

@Component({
  selector: 'app-list-permit-type-document',
  templateUrl: './list-permit-type-document.component.html',
  styleUrls: ['./list-permit-type-document.component.css'],
  providers: [PermitTypeDocumentService]
})
export class ListPermitTypeDocumentComponent implements OnInit {
  permits: any;

  carrierTypes: any = [];
  selectedPermitType: any = {};
  doctypes: any = {};
  linked: any = [];
  isChecked: boolean = false;
  refLink: any = {};
  isEdit: boolean = false;
  doctype: string = "";
  isActivated: boolean = false;
  selected = true;
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';
  audit = { created: '', updated: '' };
  user = { LastName: '' };

  popoverTitle = 'Delete Carrier Type Document Link';
  popoverMessage = 'Are you sure you want to delete Carrier Type Document Link?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading permit Type Document Links...";

  public isLoading = false;
  isEmpty: boolean = false;
  code: any;
  description: any;
  permitUnLinkId: any
  permitLinkId: any
  linkCode: any
  selectedUnLinkIndex: any;
  selectedLinkIndex: any
  selectPermitDocumentLink: any = null
  selectPermitDocumentUnlink: any = null
  documentLinkDelinkAction = DOCUMENT_LINK_DELINK_ACTION
  showTable:boolean=false
  constructor(
    private service: PermitTypeDocumentService, private authWebService: AuthWebService,
    private utility: UtilityServiceService, private toastr: ToastrService, private router: Router,
private toastService:ToastNotificationService,
    
  ) { }


  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';

    this.getAllPermits();
  }
  getAllPermits() {
    this.service.getAll().subscribe(data => {
      this.permits = data;
    });
  }

  onChange() {
    this.linked = [];
    this.isChecked = false;
    if (this.selectedPermitType.id > 0)
    this.showTable=true
      this.code = this.selectedPermitType.code;
    this.description = this.selectedPermitType.description;
    this.onReloadLinks(this.selectedPermitType.id);

  }
  onReloadLinks(id: number, show: boolean = true) {
    this.message = "Loading document types, please wait...";
    this.isActivated = show;
    this.service.getLinkedAndUnlinkedDoctypes(id).subscribe(
      result => {
        this.doctypes = result;
        this.isActivated = false;
        this.isLoading = false;
      },
      error => {
        //console.log(error);
        this.isActivated = false;
        this.isLoading = false;
      }
    );
  }
  isInList(id: number) {
    let count = this.linked.length;
    for (let iter = 0; iter < count; iter++) {
      if (this.linked[iter].document_type_id == id) return iter;
    }
    return -1;
  }
  onCheck(id: number) {
    let val: PermitLinked = {
      id: undefined,
      document_type_id: id,
      permit_type_id: this.selectedPermitType.id,
      is_active: true,
      is_mandatory: false,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    this.isChecked = true;
    let index = this.isInList(id);
    if (index == -1) this.linked.push(val);
    else this.linked[index] = val;


  }
  onPop(id: number) {

    this.isChecked = true;
    let index = this.isInList(id);
    //console.log("remove item");
    if (index != -1) this.linked.splice(index, 1);



  }
  onDelete(id: number, doctype: string) {
    this.message = `Unlinking ${this.doctype}, please wait...`;
    this.isLoading = true;
    this.isActivated = true;
    this.service.deleteLink(id).subscribe(
      result => {
        this.selectedLinkIndex = null
        this.isActivated = false;
        this.linked = [];
        this.onReloadLinks(this.selectedPermitType.id, false);
        // this.dialogService.addDialog(AlertComponent, { title: 'Unlink Document Type', message: `Document type ${doctype} linked to ${this.selectedPermitType.code} unlinked succesfully.`, bold: `${this.selectedPermitType.code}` });
        this.toastService.success(`Document type ${doctype} linked to ${this.selectedPermitType.code} unlinked succesfully.`, 'Unlink Document Type')
        //console.log(result);
      },
      error => {
        this.isActivated = false;
        //console.log(error);
      }
    );
  }

  OnSaveLinks(id) {
    let val: PermitLinked = {
      id: undefined,
      document_type_id: id,
      permit_type_id: this.selectedPermitType.id,
      is_active: true,
      is_mandatory: false,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    //console.log(val);
    this.message = "Linking selected document type(s), please wait...";
    this.isLoading = true;
    this.isActivated = true;
    this.service.addToLinks(val).subscribe(
      result => {
        this.isActivated = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Linking Document Type(s)', message: `Document type(s) linked to ${this.selectedPermitType.code} succesfully.`, bold: `${this.selectedPermitType.code}` });
        this.selectedUnLinkIndex = null;
        this.toastr.success(`Document type(s) linked to ${this.selectedPermitType.code} succesfully.`, 'Unlink Document Type');
        this.onReloadLinks(this.selectedPermitType.id, false);
      },
      error => {
        //console.log(error);
        this.isActivated = false;
      }
    );

  }
  onEdit(id: any, doctype: any) {
    this.doctype = doctype;

    this.isEdit = true;
    this.service.getLinkById(id).subscribe(
      result => {
        this.refLink = result;
        this.refLink.DocumentType = doctype;
      },
      error => {
        //console.log(error);
      }
    );
  }
  onUpdateLink(event, id, selectedPermitType) {
    //console.log(event.target.checked);
    if (event.target.checked) {

      this.message = `Update link between ${this.doctype} and ${this.selectedPermitType.code}, please wait...`;
      this.isActivated = true;
      let link: PermitLinked = {
        id: id,
        document_type_id: selectedPermitType.document_type_id,
        permit_type_id: selectedPermitType.permit_type_id,
        is_active: selectedPermitType.is_active,
        is_mandatory: true,
        date_created: selectedPermitType.date_created,
        user_created: selectedPermitType.user_created,//To be changed
        user_modified: selectedPermitType.user_created,//To be changed
        date_modified: new Date()
      };
      //console.log(link);

      this.service.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedPermitType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, bold: `${this.selectedPermitType.code}` });
          this.toastService.success(`Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, 'Unlink Document Type');
        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }
    if (!event.target.checked) {

      this.message = `Update link between ${this.doctype} and ${this.selectedPermitType.code}, please wait...`;
      this.isActivated = true;
      let link: PermitLinked = {
        id: id,
        document_type_id: selectedPermitType.document_type_id,
        permit_type_id: selectedPermitType.permit_type_id,
        is_active: selectedPermitType.is_active,
        is_mandatory: false,
        date_created: selectedPermitType.date_created,
        user_created: selectedPermitType.user_created,//To be changed
        user_modified: selectedPermitType.user_created,//To be changed
        date_modified: new Date()
      };
      //console.log(link);

      this.service.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedPermitType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, bold: `${this.selectedPermitType.code}` });
          this.toastService.success(`Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, 'Unlink Document Type');

        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }
  }

  checkedPermitDocUnlink(ev: any, optionalVal, res, index) {
    this.permitUnLinkId = res?.id
    this.selectedUnLinkIndex = ev.target.checked ? index : undefined;
    if (ev.target.checked) {
      this.selectPermitDocumentUnlink = res;
    } else {
      this.selectPermitDocumentUnlink = null;
    }

  }

  checkedPermitDocLink(ev: any, optionalVal, res, index) {
    this.permitLinkId = res?.id
    this.linkCode = res?.code
    this.selectedLinkIndex = ev.target.checked ? index : undefined;
    if (ev.target.checked) {
      this.selectPermitDocumentLink = res;
    } else {
      this.selectPermitDocumentLink = null;
    }

  }

  doPermitTypeDocAction(event: any) {
    if (event.value == LINK_PERMITS_DOCUMENT_ACTIONS.Delink) {
      (this.selectPermitDocumentUnlink == null) ? this.toastService.error('Please select the link document first!','') : this.OnSaveLinks(this.permitUnLinkId);

    } else {
      if (event.value == LINK_PERMITS_DOCUMENT_ACTIONS.Link) {
        (this.selectPermitDocumentLink == null) ? this.toastService.error('Please select the unlink document first!','') : this.onDelete(this.permitLinkId, this.linkCode);
      }
    }
  }
  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Carrier Type Documents' : 'Delete Carrier Type Document';
  }
  onCancel() {
    this.isEdit = false;
  }


}
